import APIV3 from '../../../api/axios/APIV3';

export const fetchSearchedItems = async (keyword) => {
    const response = await APIV3.get(`restaurants/:restaurantId/items?keyword=${keyword}`);

    return response;
};
